module.exports = __webpack_public_path__ + "img/chania.e680a700.jpg";